
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { REPORTS } from '@/constants/constants';
import { Team } from '@run-diffusion/shared';
import { TeamReportEmbedUrlsDataState } from '@/store';

export default Vue.extend({
	name: 'CompanyUsageReport',
	metaInfo() {
		return {
			title: 'Runnit Company Usage',
		};
	},
	props: {
		selectedTeam: { type: Object, default: null },
		selectedCompany: { type: Object, default: null },
		defaultTeamMemberEmail: { type: String, default: null },
	},
	data () {
		return {
			// Dashboards
			teamMetricsDashboardUrl: null,
		};
	},
	watch: {
		selectedTeam: {
			immediate: true,
			async handler (newVal: Team, oldVal: Team) {
				if (newVal !== oldVal) {
					await this.loadTeamReportEmbedUrls({
						team: newVal,
						company: this.selectedCompany,
						teamMemberEmail: this.defaultTeamMemberEmail,
					});
				}
			},
		},
		teamReportEmbedUrlsData: {
			immediate: true,
			handler (newVal: TeamReportEmbedUrlsDataState, oldVal: TeamReportEmbedUrlsDataState) {
				if (newVal !== oldVal) {
					// Check for company dashboard (201) first, then team dashboard (265)
					this.teamMetricsDashboardUrl = this._get(newVal, `dashboards[${REPORTS.DASHBOARDS.COMPANY_USAGE_DASHBOARD}]`) ||
						this._get(newVal, `dashboards[${REPORTS.DASHBOARDS.TEAM_USAGE_DASHBOARD}]`);
				}
			},
		},
	},
	computed: {
		...mapState([
			'user',
			'teamReportEmbedUrlsData',
			'teamReportEmbedUrlsDataLoading',
		]),
	},
	methods: {
		...mapActions([
			'loadTeamReportEmbedUrls',
		]),
	},
});
